import doc                            from '@widesk-core/decorators/doc';
import AbstractPartnershipStatusModel from './AbstractPartnershipStatusModel';
import model                          from '@widesk-core/decorators/model';

@doc.urnResource('partnership_status')
@model.cacheDuration()
export default class PartnershipStatusModel extends AbstractPartnershipStatusModel {
	public get color() {
		switch (this.reference) {
			case 'ENABLED':
				return 'green';
			case 'DISABLED':
				return 'red';
		}
	}
}
